export default __webpack_public_path__ + "media/images/ongletwhite-rightlast2-9f5702c0a1b0fbf34581dab9450183d1.png";